import { useTranslation } from 'react-i18next';
import { PageType } from '@vgtv/api-client/lib/page';

import { PageComponents } from '../components/PageComponents/PageComponents';
import { PageMetadata } from '../components/PageMetadata/PageMetadata';
import { NOT_FOUND_PAGE_SLUG } from '../consts';
import { usePageViewTracking } from '../components/utils/usePageViewTracking';
import { config } from '../config';

import { usePageConfig } from './usePageConfig';

import type { FC } from 'react';

import * as styles from './NotFoundPage.module.scss';

const NotFoundPage: FC = () => {
  const { pageConfig } = usePageConfig({
    identifier: NOT_FOUND_PAGE_SLUG,
    pageType: PageType.CUSTOM,
    vendor: config.provider,
  });
  const { t } = useTranslation();

  usePageViewTracking({
    pageType: PageType.CUSTOM,
    entity: pageConfig ? { slug: pageConfig.slug } : undefined,
  });

  return (
    <>
      <h2 className={styles.heading}>{t('Not found')}</h2>
      {pageConfig && (
        <PageComponents componentsConfig={pageConfig.components} />
      )}
      {pageConfig && (
        <PageMetadata
          pageType={PageType.CUSTOM}
          entity={pageConfig}
          overrides={{ title: t('Not found') }}
        />
      )}
    </>
  );
};

export { NotFoundPage };
